<template>
    <div :class="containerClass" v-if="isShow">
        <label v-if="labelStatus"
            class="fw-bold"
            :for="id"
            :style="inputLable"
        >
        {{ label }}
        <span v-if="required" class="required-fields">*</span>
        </label>
        <select
            :id="id"
            class="form-control"
            :value="modelValue"
            @change="updateValue($event)"
            :disabled="disabled"
        >
        <option value="" >Select {{ placeholder }}</option>
        <option 
            v-for="option in options" 
            :key="option.value" 
            :value="option.value" 
            :disabled="isDisabled(option.value)"
        >
            {{ option.text }}
        </option>
        </select>
        <span v-if="required && errorStatus && modelValue.length === 0" class="text-danger mt-1" :style="inputErrorMsg">
            Select {{ label }}
        </span>
    </div>
</template>
  
<script>

export default {
    name: "SelectBox",
    props: {
        label: {
            type: String,
            default: "",
        },
        modelValue: {
            type: [String, Number],
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
        colClass: {
            type: String,
            default: "col-md-3",
        },
        required: {
            type: Boolean,
            default: true,
        },
        options: {
            type: Array,
            default: () => [],
        },
        inputLable: {
            type: Object,
            default: () => ({
                fontSize: '14px',
            }),
        },
        inputErrorMsg: {
            type: Object,
            default: () => ({
                fontSize: '10px',
            }),
        },
        errorStatus: {
            type: Boolean,
            default: false,
        },
        labelStatus: {
            type: Boolean,
            default: true,
        },
        marginTop: {
            type: String,
            default: "mt-3",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        selectedOptions: {
            type: Array,
            default: () => [],
        },
        searchName: {
            type: String,
            default: "",
        },
        isShow: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        containerClass() {
            return `${this.colClass} ${this.marginTop}`;
        },
        placeholder() {
            return this.label.toLowerCase()
        }
    },
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.target.value);
        },
        isDisabled(value) {
            return this.selectedOptions.some((selectedItem) => selectedItem[this.searchName] === value);
        }
    },
};
</script>
  
<style scoped>
.required-fields {
    color: red;
}
</style>
  